import React from 'react'
import  WaitingUpdatesChannel from 'acable_channels/waiting_updates'
import { Line } from 'rc-progress'
import notificationBlocker from 'libs/notifications_blocker'

notificationBlocker.addCatchFor('campaign_waiting_update')

const POLL_INTERVAL = 2000

export default class WaitProcessing extends React.Component {

  constructor (props) {
    super(props)
    this.state = { value: '' }
    this._redirecting = false
    // ActionCable gives a smooth, live bar when it is connected in time; the poll
    // below is the source of truth and recovers progress/redirect if it isn't.
    this.updatesChannel = new WaitingUpdatesChannel(this.channelData(), this.onReceivedHandler)
  }

  onReceivedHandler = (payload) => {
    if (payload.value || payload.value == 0) { this.setValue(payload.value) }
    if (payload.location) { this.redirectTo(payload.location) }
  }

  // Move the bar forward only; avoids backward flicker when a slower poll response
  // arrives after a higher value already came in over the channel.
  setValue = (value) => {
    this.setState(state => (state.value === '' || value > state.value) ? { value } : null)
  }

  redirectTo = (location) => {
    if (this._redirecting) { return }
    this._redirecting = true
    clearTimeout(this._pollTimer)
    window.location.href = location
  }

  channelData = () => ({
      channel: 'WaitingUpdatesChannel',
      room: 'Campaign',
      id: this.props.id
  })

  poll = () => {
    const { id, step, stepAction } = this.props
    const stepActionParam = stepAction ? `&step_action=${stepAction}` : ''
    ajax({
      url: `/campaigns/${id}/wait-processing.json?step=${step}${stepActionParam}`,
      method: 'get'
    }).then(resp => {
      if (resp.data.location) {
        this.redirectTo(resp.data.location)
      } else {
        if (resp.data.percent != null) { this.setValue(resp.data.percent) }
        this.scheduleNextPoll()
      }
    }).catch(() => this.scheduleNextPoll())
  }

  scheduleNextPoll = () => {
    if (this._redirecting) { return }
    this._pollTimer = setTimeout(this.poll, POLL_INTERVAL)
  }

  componentDidMount () {
    this.poll()
  }

  componentWillUnmount () {
    clearTimeout(this._pollTimer)
    if (this.updatesChannel) { this.updatesChannel.unsubscribe() }
  }

  render () {
    if (this.state.value === '') { return null }
    return (
      <div>
        <Line percent={this.state.value} strokeWidth="1" strokeColor="#007bff" />
        <div>{this.state.value}%</div>
      </div>
    )
  }
}
